import { apiSolicitudProspecto, apiSolicitudProspectoEditar } from "../settings/apiConfig";
import { createContext, useContext, useEffect, useState } from "react";

import { enumProveedorStep } from "../settings/enumConfig";
import { fnHandleChangeChek } from "../settings/handleConfig";
import { getConfirmarForm } from "../model/confirmarModel";
import { useDatosCompania } from "./DatosCompaniaContext";
import { useDomicioFiscal } from "./DomicilioFiscalContext";
import { useGiroPrincipal } from "./GiroPrincipalContext";
import { useInformacionComplementaria } from "./InformacionComplementariaContext";
import { useProveedoresProspectos } from "./ProveedoresProspectosContext";
import { useRequest } from "./RequestContext";

export const ConfirmarSolicitudContext = createContext();

export const ConfirmarSolicitudProvider = (props) => {
    const { PostFormData } = useRequest();
    const { provedoresSteps, entSolicitudDetalleForEdit, handleChangeProveedoresStep, handleClickResetStepError, handleChangeStep } =
        useProveedoresProspectos();
    const { datosCompaniaEnt, cartaPresentacionArhivo, constanciaSituacionFiscal } = useDatosCompania();
    const { actividadSeleccionada, lstActividadesSecundariasSeleccionadas } = useGiroPrincipal();
    const { entDomicilioFiscal } = useDomicioFiscal();
    const { entInformacionComplementaria } = useInformacionComplementaria();

    const [confirmarForm, setConfirmarForm] = useState(getConfirmarForm());
    const [folioRespuesta, setFolioRespuesta] = useState("");

    const [errorAvisoPrivacidad, setErrorAvisoPrivacidad] = useState(false);
    const [errorGuardadoMessage, setErrorGuardadoMessage] = useState("");
    const [entSolicitudProspecto, setEntSolicitudProspecto] = useState(null);
    const [enviando, setEnviando] = useState(false);
    const [exito, setExito] = useState(false);
    const [error, setError] = useState(false);

    const handleChangeConfirmarCheck = fnHandleChangeChek(confirmarForm, setConfirmarForm);

    const handleClickRegresar = () => {
        handleChangeStep(enumProveedorStep.InformacionComplementaria);
    };

    const handleClickEnviarSolicitud = () => {
        const { txtAvisoPrivacidad } = confirmarForm;

        if (!txtAvisoPrivacidad.value) {
            setErrorAvisoPrivacidad(true);
            handleChangeProveedoresStep(
                provedoresSteps.map((x) => ({ ...x, error: x.id === enumProveedorStep.EnviarSolicitud ? true : false }))
            );
            return;
        }

        const entSolicitudProspectoTemp = {
            entDatosCompania: datosCompaniaEnt,
            entGiroPrincipal: {
                entActividadPrincipal: { iIdActividadEconomica: actividadSeleccionada.iIdActividadEconomica },
                lstActividadesAdicionales: lstActividadesSecundariasSeleccionadas.map((x) => ({ iIdUnspscJoinEsEn: x.iIdUnspscJoinEsEn })),
            },
            entDomicilioFiscal: entDomicilioFiscal,
            entInformacionComplementaria: entInformacionComplementaria,
            bAceptoAvisoPrivacidad: txtAvisoPrivacidad.value,
        };

        setErrorAvisoPrivacidad(false);
        handleClickResetStepError();
        setEnviando(true);
        setEntSolicitudProspecto(entSolicitudProspectoTemp);
    };

    const handleClickReintentar = () => {
        setExito(false);
        setError(false);
    };

    const handleSubmitFormSolicitud = async () => {
        const form = new FormData();
        form.append("entSolicitud", JSON.stringify(entSolicitudProspecto));

        if (cartaPresentacionArhivo) {
            form.append("cartaPresentacion", cartaPresentacionArhivo);
        }
        if (constanciaSituacionFiscal) {
            form.append("situacionFiscal", constanciaSituacionFiscal);
        }

        let response;
        if (entSolicitudDetalleForEdit) {
            const { iIdSolicitudProveedor } = entSolicitudDetalleForEdit;
            response = await CInsSolicitudProspectoEdit(form, iIdSolicitudProveedor);
        } else {
            response = await CInsSolicitudProspecto(form);
        }

        setEnviando(false);

        if (response.Code === 0) {
            setError(false);
            setExito(true);
            setFolioRespuesta(response.Result);
            handleChangeStep(enumProveedorStep.SolicitudEnviada);
            window.onbeforeunload = null;
        } else {
            setError(true);
            setExito(false);
            setFolioRespuesta("");
            setErrorGuardadoMessage(response.Message);
            handleChangeProveedoresStep(
                provedoresSteps.map((x) => ({ ...x, error: x.id === enumProveedorStep.EnviarSolicitud ? true : false }))
            );
        }
    };

    const CInsSolicitudProspecto = async (body) => {
        const payload = {
            url: apiSolicitudProspecto,
            body,
        };

        return await PostFormData(payload);
    };

    const CInsSolicitudProspectoEdit = async (body, piIdSolicitudProveedor) => {
        const payload = {
            url: apiSolicitudProspectoEditar.replace("{piIdSolicitudProveedor}", piIdSolicitudProveedor),
            body,
        };

        return await PostFormData(payload);
    };

    useEffect(() => {
        if (entSolicitudProspecto !== null && enviando) {
            handleSubmitFormSolicitud();
        }
        // eslint-disable-next-line
    }, [entSolicitudProspecto]);

    return (
        <ConfirmarSolicitudContext.Provider
            value={{
                confirmarForm,
                errorAvisoPrivacidad,
                folioRespuesta,
                enviando,
                exito,
                error,
                errorGuardadoMessage,
                handleChangeConfirmarCheck,
                handleClickRegresar,
                handleClickEnviarSolicitud,
                handleClickReintentar,
            }}
        >
            {props.children}
        </ConfirmarSolicitudContext.Provider>
    );
};

export const useConfirmarSolicitud = function () {
    return useContext(ConfirmarSolicitudContext);
};
